module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_mobile_6-5ebc26a5af71298c29578f71880e978e.png";